// 合同管理
const List = () => import('@/pages/customRecycle/list.vue');

const arr = [
  // 客户公海
  {
    path: '/cusRecycle',
    name: 'customRecycleList',
    component: List,
    meta: {
      auth: false,
    },
  },
];

export default arr;
